import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetCashtagStatusRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetCashtagStatusResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getCashtagStatus = (request: GetCashtagStatusRequest, options?: CashRequestOptions) =>
  post<GetCashtagStatusRequest, GetCashtagStatusResponse>('/2.0/cash/get-cashtag-status', request, {
    ...options,
    rejectOnError: true,
  })
